<template lang="html">

  <div>

    <section class="idioma">
      <button @click="langselected = 'ca'" :active="lang == 'ca'">CA</button>
      <button @click="langselected = 'es'" :active="lang == 'es'">ES</button>
    </section>

    <div class="cover-popup row-center" v-if="langselected">
      <div class="popup">
        <p>{{$t('popup_idioma')}}</p>
        <div class="contenedor-botones row-center">
          <button @click="requestLangChange" class="btn -xs" :style="styles.solidPrimary">{{$t('si')}}</button>
          <button @click="langselected = ''" class="btn -xs" :style="styles.skull_primary">{{$t('no')}}</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'idioma',
    data: () => ({
      show: true,
      langselected : ''
    }),
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange() {
        this.changeLanguage(this.langselected).then(() => {
          this.langselected = '';
        });
      },
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage',
        styles: 'getStyles',
      })
    }
  }
</script>

<style scoped lang="scss">
  .idioma {
    margin-left: 10px;
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    padding-bottom: 5px;

    span {
      text-transform: uppercase;
      height: 25px;
      line-height: 25px;
      cursor: pointer;
      width: 100%;
      background: red;
      display: inline-block;
      text-align: left;
    }

    button {
      background: transparent;
      padding: 0 10px;
      border: none;
      text-transform: uppercase;
      font-size: 18px;
      border-right: 1px solid white;
      cursor: pointer;

      &[active=true] {
        font-weight: bold;
      }

      &:last-child {
        border: none;
      }
    }


  }

  .cover-popup{
    transform: translate(0%, 0%);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  }

  .popup {
    min-height: 150px;
  }

  .popup p {
    width: 100%;
    text-align: left;
    font-weight: bold;
    color: black;
    margin-bottom: 20px;
  }

  .popup .btn{
    margin: 0 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/idioma.vue